<p-dialog
  #dialog
  *ngIf="visible"
  [style]="{ width }"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [closable]="closable"
  [closeOnEscape]="closable"
  [maximizable]="maximizable"
  [resizable]="false"
  (onShow)="!!maximizable && dialog.maximize()"
  (onHide)="onClose()"
  (visibleChange)="onChangeVisible($event)"
>
  <ng-template *ngIf="options?.header" pTemplate="header">
    <div class="header">{{ options?.header }}</div>
  </ng-template>

  <ng-container *ngIf="contentTemplateRef">
    <div class="content">
      <ng-container *ngTemplateOutlet="contentTemplateRef; context: { data: this.data }"></ng-container>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <p-button
      *ngIf="options && options.acceptButton"
      type="button"
      [label]="options.acceptButton"
      (click)="onAccept()"
    />

    <p-button
      *ngIf="options && options.rejectButton"
      type="button"
      [outlined]="true"
      [label]="options.rejectButton"
      (click)="onReject()"
    />

    <p-button
      *ngIf="options && options.closeButton"
      type="button"
      [outlined]="true"
      [label]="options.closeButton"
      (click)="onClose()"
    />
  </ng-template>
</p-dialog>
